import classnames from "classnames";
import { getInitials } from "@helpers/utils";

const sizeClassMap = {
  sm: "h-6 w-6 text-xs",
  md: "h-8 w-8 text-sm",
  lg: "h-12 w-12 text-base",
  xl: "h-16 w-16 text-lg"
};

const lightBgMap = {
  primary  : "bg-primary/15 text-primary",
  secondary: "bg-secondary/15 text-secondary",
  success  : "bg-success/15 text-success",
  danger   : "bg-danger/15 text-danger",
  warning  : "bg-warning/15 text-warning",
  info     : "bg-info/15 text-info"
};

const solidBgMap = {
  primary  : "bg-primary text-white",
  secondary: "bg-secondary text-white",
  success  : "bg-success text-white",
  danger   : "bg-danger text-white",
  warning  : "bg-warning text-white",
  info     : "bg-info text-white"
};

const statusColorMap = {
  online : "bg-success",
  offline: "bg-gray-400",
  away   : "bg-warning",
  busy   : "bg-danger"
};

const Avatar = (props) => {
  // ** Props
  const {
    img,
    size,
    icon,
    color,
    status,
    badgeUp,
    content,
    tag: Tag = "div",
    initials,
    className,
    badgeText,
    imgClassName,
    contentStyles,
    light = true,
    rounded = false,
    disabled,
    alt,
    ...rest
  } = props;
  const tempSize = icon?.type ? "md" : size;
  const IconComp = icon?.type ? null : icon;
  return (
    <Tag
      className={classnames(
        "relative inline-flex items-center justify-center overflow-hidden",
        sizeClassMap[tempSize] || sizeClassMap.md,
        color && (light ? lightBgMap[color] : solidBgMap[color]),
        rounded ? "rounded-full" : "rounded",
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {img === false || img === undefined || img === null ? (
        <span
          className={classnames(
            "flex items-center justify-center font-medium",
            {
              relative        : badgeUp,
              "cursor-pointer": !disabled
            }
          )}
          style={contentStyles}
        >
          {initials ? getInitials(content) : content}

          {icon
            ? icon.type
              ? icon
              : IconComp && <IconComp size={16} />
            : null}
          {badgeUp ? (
            <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] text-white">
              {badgeText || "0"}
            </span>
          ) : null}
        </span>
      ) : (
        <img
          className={classnames("h-full w-full object-cover", imgClassName, {
            "cursor-pointer": !disabled
          })}
          src={img}
          id="avatar-img"
          alt={alt}
          height={32}
          width={32}
        />
      )}
      {status ? (
        <span
          className={classnames(
            "absolute bottom-0 right-0 h-2 w-2 rounded-full border border-white",
            statusColorMap[status]
          )}
        ></span>
      ) : null}
    </Tag>
  );
};

export default Avatar;
